var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgShare = (_ref) => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 512 512",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m416 159.9-8-.165c-13.25 0-24 10.75-24 24.02 0 13.26 10.75 24.02 24 24.02h8c8.836 0 16 7.17 16 16.01v224.2c0 8.842-7.164 16.01-16 16.01H96c-8.836 0-16-7.169-16-16.01V223.8c0-8.842 7.164-16.01 16-16.01h8c13.25 0 24-10.75 24-24.02s-10.75-24.02-24-24.02l-8 .15c-35.35 0-64 28.51-64 63.88v224.2C32 483.3 60.65 512 96 512h320c35.35 0 64-28.68 64-64.04V223.8c0-35.4-28.7-63.9-64-63.9zm-256-8.1c6.47 0 12.91-2.614 17.62-7.752L232 85.08v234.8c0 13.26 10.75 24.02 24 24.02s24-10.76 24-24.02V85.08l54.38 58.95c4.72 5.17 11.12 7.67 17.62 7.67 13.23 0 24-10.77 24-24.05a23.85 23.85 0 0 0-6.376-16.26l-96-104.1C269.1 2.455 262.5 0 256 0s-13.1 2.455-17.6 7.365l-96 104.1c-4.3 4.635-7.3 10.435-7.3 16.235 0 13.4 11.8 24.1 24.9 24.1z"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgShare, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/share.c8c9a607.svg";
export { ForwardRef as ReactComponent };